import "./tabs.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React from "react";
import { DatePicker } from "antd";
import Loading from "../../../loader/loader";
import NkTable from "../../nktable";
import moment from "moment";
const Billerspresentaional = ({
  searchBy,
  setSearchBy,
  setSearchByValue,
  searchByValue,
  searchByValuePlaceholder,
  handleFilter,
  setFromDate,
  fromDate,
  setToDate,
  toDate,
  setShowFilterModal,
  filtersSelected,
  resetFilter,
  noOfFiltersSelected,
  billerdetails,
  columns,
  pagination,
  setFilterForm,
  setSizeShow,
  dataLoading,
  filterForm,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchBy(e.target.value);
                setSearchByValue("");
              }}
            >
              <option value="nickName">Nick Name</option>
              <option value="billerName">Biller name</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <div
          lg="1"
          className="form-input-padding-tab"
          style={{ marginTop: "2px" }}
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Filter by
            </Label>
            <div>
              <Button
                style={{ width: "100%", height: "26px" }}
                color="primary"
                type="button"
                id="example3cols2Input"
                className="filter-button"
                onClick={() => setShowFilterModal(true)}
              >
                <div>
                  {" "}
                  <i class="fas fa-filter"></i>
                </div>
              </Button>
            </div>
          </FormGroup>

          <span style={{ fontSize: 8 }}>
            {filtersSelected && noOfFiltersSelected > 0 ? (
              <>
                <h6 style={{ display: "flex", alignItems: "center" }}>
                  Selected({noOfFiltersSelected})
                  <i
                    class="fas fa-window-close"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => {
                      setSearchByValue("");
                      resetFilter();
                    }}
                  />
                </h6>
              </>
            ) : (
              <></>
            )}
          </span>
        </div>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFilter(true)}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {billerdetails.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={billerdetails}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          page: pageSize,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
    </>
  );
};
export default Billerspresentaional;
